@let a = abschluss();
<div class="rm-sum">
  <section class="rm-doc__sec">
    <h3 class="rm-doc__sec-title">
      <span class="rm-doc__nr">1</span>
      {{ 'testResults.report.doc.abschluss.recommendation' | translate }}
    </h3>
    <div class="rm-sum__rec">
      @if (ampel(); as state) {
        <app-ampel-badge size="sm" [state]="state" [offeneFehler]="offeneFehlerKeys()" />
      }
    </div>
    <p class="rm-doc__note" data-testid="report-criteria-line">
      {{ 'testResults.report.doc.abschluss.criteriaLine' | translate: { muss: failedMuss(), soll: failedSoll() } }}
    </p>
  </section>
  <section class="rm-doc__sec">
    <h3 class="rm-doc__sec-title">
      <span class="rm-doc__nr">2</span>
      {{ 'testResults.report.doc.abschluss.scope' | translate }}
    </h3>
    <dl class="rm-facts">
      <dt>{{ 'testResults.report.doc.abschluss.candidate' | translate }}</dt>
      <dd>—</dd>
      <dt>{{ 'testResults.report.sections.umfang' | translate }}</dt>
      <dd>
        {{ scopeLabel() }} ·
        {{
          'testResults.report.doc.abschluss.plans.' + (a.planErgebnisse.length === 1 ? 'one' : 'other')
            | translate: { count: a.planErgebnisse.length }
        }}
        ·
        {{
          'testResults.report.doc.abschluss.cases.' + (a.gesamt === 1 ? 'one' : 'other')
            | translate: { count: a.gesamt }
        }}
      </dd>
    </dl>
  </section>
  <section class="rm-doc__sec">
    <h3 class="rm-doc__sec-title">
      <span class="rm-doc__nr">3</span>
      {{ 'testResults.report.doc.abschluss.results' | translate }}
    </h3>
    <div class="rm-sum__tiles">
      <div class="rm-tile" data-tile="ausgefuehrt">
        <div class="rm-tile__label">{{ 'testResults.report.summary.executed' | translate }}</div>
        <div class="rm-tile__value">{{ a.ausgefuehrt }}/{{ a.gesamt }}</div>
      </div>
      <div class="rm-tile" data-tile="passrate">
        <div class="rm-tile__label">{{ 'testResults.report.summary.passRate' | translate }}</div>
        <div class="rm-tile__value">{{ a.ausgefuehrt === 0 ? '—' : a.passRate + '%' }}</div>
      </div>
      <div class="rm-tile rm-tile--failed" data-tile="failed">
        <div class="rm-tile__label">{{ 'testResults.report.summary.failed' | translate }}</div>
        <div class="rm-tile__value">{{ a.failed }}</div>
      </div>
      <div class="rm-tile rm-tile--blocked" data-tile="blocked">
        <div class="rm-tile__label">{{ 'testResults.report.summary.blocked' | translate }}</div>
        <div class="rm-tile__value">{{ a.blocked }}</div>
      </div>
    </div>
    @if (a.planErgebnisse.length > 0) {
      <table class="rm-table">
        <thead>
          <tr>
            <th scope="col">{{ 'testResults.report.doc.plan' | translate }}</th>
            <th scope="col">{{ 'testResults.report.doc.abschluss.total' | translate }}</th>
            <th scope="col">{{ 'testResults.report.doc.abschluss.passed' | translate }}</th>
            <th scope="col">{{ 'testResults.report.doc.abschluss.failed' | translate }}</th>
            <th scope="col">{{ 'testResults.report.summary.blocked' | translate }}</th>
            <th scope="col">{{ 'testResults.report.doc.abschluss.open' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (p of a.planErgebnisse; track p.planId) {
            <tr data-testid="report-plan-result">
              <td>
                <code class="rm-code">{{ p.planKey }}</code>
                {{ p.titel }}
              </td>
              <td>{{ p.gesamt }}</td>
              <td>{{ p.passed }}</td>
              <td [class.rm-figure--failed]="p.failed > 0">{{ p.failed }}</td>
              <td [class.rm-figure--blocked]="p.blocked > 0">{{ p.blocked }}</td>
              <td>{{ p.offen }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </section>
  <section class="rm-doc__sec">
    <h3 class="rm-doc__sec-title">
      <span class="rm-doc__nr">4</span>
      {{ 'testResults.report.doc.abschluss.defects' | translate }}
    </h3>
    @if (a.offeneDefects.length > 0) {
      <ul class="rm-defects__list">
        @for (c of a.offeneDefects; track c.planId + c.testCaseId) {
          <li class="rm-defects__row" data-testid="report-open-defect">
            <code class="rm-defects__case">{{ c.testCaseKey }}</code>
            <span class="rm-defects__title">{{ c.titel }}</span>
            @if (c.bugKey) {
              <code class="rm-defects__bug">{{ c.bugKey }}</code>
            }
            <app-defect-ref-chips [projectId]="projectId()" [defects]="c.defects" />
          </li>
        }
      </ul>
    } @else {
      <p class="rm-doc__note" data-testid="report-no-defects">
        {{ 'testResults.report.doc.abschluss.noDefects' | translate }}
      </p>
    }
  </section>
  <section class="rm-doc__sec">
    <h3 class="rm-doc__sec-title">
      <span class="rm-doc__nr">5</span>
      {{ 'testResults.report.doc.abschluss.untested' | translate }}
    </h3>
    @if (requirementsWithoutCase().length > 0) {
      <table class="rm-table">
        <tbody>
          @for (r of requirementsWithoutCase(); track r.requirementId) {
            <tr data-testid="report-untested">
              <td>
                <code class="rm-code">{{ r.requirementKey }}</code>
              </td>
              <td>{{ r.requirementTitel }}</td>
              <td>{{ 'testResults.report.doc.abschluss.noCase' | translate }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
    <p class="rm-doc__note" data-testid="report-untested-count">
      {{ 'testResults.report.doc.abschluss.untestedCount' | translate: { count: a.offen } }}
    </p>
  </section>
  <section class="rm-doc__sec">
    <h3 class="rm-doc__sec-title">
      <span class="rm-doc__nr">6</span>
      {{ 'testResults.report.doc.abschluss.criteria' | translate }}
    </h3>
    @if (a.bewertung.abweichungen.length > 0) {
      <table class="rm-table">
        <thead>
          <tr>
            <th scope="col">{{ 'testResults.report.doc.abschluss.criterion' | translate }}</th>
            <th scope="col">{{ 'testResults.report.doc.abschluss.kind' | translate }}</th>
            <th scope="col">{{ 'testResults.report.doc.abschluss.target' | translate }}</th>
            <th scope="col">{{ 'testResults.report.doc.abschluss.actual' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (k of a.bewertung.abweichungen; track k.key) {
            <tr data-testid="report-criterion">
              <td>{{ 'testResults.freigabe.bewertung.criteria.' + k.key + '.label' | translate }}</td>
              <td>{{ 'testResults.freigabe.bewertung.kind.' + (k.muss ? 'muss' : 'soll') | translate }}</td>
              <td>
                {{ 'testResults.freigabe.bewertung.criteria.' + k.key + '.soll' | translate: { wert: k.sollWert } }}
              </td>
              <td>
                @if (k.istWert === null) {
                  —
                } @else {
                  {{
                    'testResults.freigabe.bewertung.criteria.' + k.key + '.ist'
                      | translate: { wert: k.istWert, nenner: k.istNenner }
                  }}
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <p class="rm-doc__note" data-testid="report-criteria-ok">
        {{ 'testResults.report.doc.abschluss.criteriaOk' | translate }}
      </p>
    }
  </section>
  <section class="rm-doc__sec">
    <h3 class="rm-doc__sec-title">
      <span class="rm-doc__nr">7</span>
      {{ 'testResults.report.doc.abschluss.release' | translate }}
    </h3>
    @if (a.bewertung.entscheidung; as e) {
      <p class="rm-doc__note" data-testid="report-decision">
        {{ 'testResults.freigabe.bewertung.decision.' + e.entscheidung | translate }} ·
        {{ e.entschiedenVon.name || '—' }} · {{ e.entschiedenAm | date: 'dd.MM.yyyy' }}
      </p>
    }
    <div class="rm-signoffs">
      @for (o of a.bewertung.signoffs; track o.rolle) {
        <div class="rm-signoff" data-testid="report-signoff">
          <div class="rm-signoff__line" aria-hidden="true"></div>
          {{ o.name || '—' }} · {{ 'testResults.freigabe.bewertung.role.' + o.rolle | translate }} ·
          @if (o.bestaetigtAm) {
            {{ o.bestaetigtAm | date: 'dd.MM.yyyy' }}
          } @else {
            {{ 'testResults.report.doc.abschluss.date' | translate }}
          }
        </div>
      }
    </div>
  </section>
</div>
